module.exports = __webpack_public_path__ + "static/media/MDR_Logo_RGB.cfdf28a5.jpg";